import React, { Component } from "react";
import PanelHeader from "components/PanelHeader/PanelHeader";
import {
    Card,
    CardBody,
    Row,
    Col
} from "reactstrap";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import PowerBiComponent from "./PowerBiComponent";
import SettingsService from 'services/api/Setting';
import { APIRESPONSE } from "settings/shared/constants";


class PowerBI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            embedUrl: "",
            PowerBIToken: "",
            PowerBIId: ""
        }
    }

    componentDidMount() {
        this.getWidgetData()
    }


    getWidgetData = () => {
        setTimeout(() => {
            localStorage.getItem("dashboardId");
            SettingsService.getDashboardInfo(localStorage.getItem("dashboardId"))
                .then((response) => {
                    if (response.status === APIRESPONSE.SUCCESS && response.widgetsDTOS !== null && response.widgetsDTOS.length > 0) {
                        let widgetsDTOS = response.widgetsDTOS[0];
                        if(widgetsDTOS.widgetData !== null && widgetsDTOS.widgetData.length > 0){
                            let widgetItem = widgetsDTOS.widgetData[0];
                            this.setState({
                                embedUrl: widgetItem.embedUrl,
                                PowerBIToken: widgetItem.PowerBIToken,
                                PowerBIId: widgetItem.PowerBIId
                            })
                        }else{
                            this.setState({
                                embedUrl: "",
                                PowerBIToken: "",
                                PowerBIId: ""
                            })
                        }
                        
                    } else {
                        this.setState({
                            embedUrl: "",
                            PowerBIToken: "",
                            PowerBIId: ""
                        })
                    }
                })
        }, 2000)

    }

    render() {
        return (
            <>
                <PanelHeader
                    content={
                        <div className="header text-center">
                        </div>
                    }
                />
                <div className="content">
                    <LoadingOverlay
                        active={this.state.loading}
                        spinner={<ScaleLoader
                            height={35}
                            width={5}
                            radius={2}
                            margin={2}
                            color={"#123abc"}
                            loading={this.state.loading}
                        />}
                    >
                        <Row>
                            <Col xs={12} md={12}>
                                <Card>
                                    <CardBody>
                                        <div id="report-container">
                                            <PowerBiComponent 
                                            embedUrl={this.state.embedUrl}
                                            PowerBIId={this.state.PowerBIId}
                                            PowerBIToken={this.state.PowerBIToken}/>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </LoadingOverlay>
                </div>
            </>
        )

    }
}

export default PowerBI;
